var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 47,
    viewBox: "0 0 44 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8638 16.2946C41.4706 15.2647 40.8426 14.3363 40.0526 13.6168C39.2626 12.8973 38.3428 12.4162 37.3996 12.229L11.6082 6.8907C10.5703 6.66861 9.54852 6.81051 8.6839 7.29682C7.81928 7.78313 7.15445 8.58985 6.78118 9.60564C6.40791 10.6214 6.34462 11.7962 6.60004 12.9677C6.85545 14.1393 7.41699 15.2498 8.20712 16.1461L15.5594 24.549C15.7268 24.7404 15.8627 24.9631 15.9586 25.2029C16.0545 25.4428 16.1084 25.6947 16.1169 25.9431L16.2936 36.8353C16.3001 37.9776 16.6211 39.1468 17.2128 40.1837C17.8046 41.2205 18.6383 42.0746 19.6004 42.6295L19.7143 42.696C20.6984 43.2481 21.7625 43.4611 22.7575 43.3049C23.7525 43.1488 24.6284 42.6314 25.2625 41.8253L41.262 22.0467C41.8413 21.3347 42.2047 20.4187 42.3111 19.4022C42.4175 18.3857 42.2625 17.3092 41.8638 16.2946Z",
    fill: "#F06F30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.484d18926a31b109b588bd3e0e1fba5e.svg";
export { ForwardRef as ReactComponent };